import { render, staticRenderFns } from "./_idnew.vue?vue&type=template&id=0766948c"
import script from "./_idnew.vue?vue&type=script&lang=js"
export * from "./_idnew.vue?vue&type=script&lang=js"
import style0 from "./_idnew.vue?vue&type=style&index=0&id=0766948c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports